import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class GioValidations {

  static isEqualString(value: any, exactCase = true): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const controlValue: string = control.value;
      if (controlValue == null) {
        return null;
      }
      if (controlValue == value) {
        return null;
      }
      if (!exactCase) {
        if (controlValue.toLowerCase() == value.toLowerCase()) {
          return null;
        }
      }
      return { isEqualString: { value: false } };
    };
  }
}
